import React, { useEffect, useState } from "react";
import { HorizontalBar } from "@reactchartjs/react-chart.js";
import { Typography } from "@mui/material";
import Cargando from "../components/Cargando/Cargando";
const options = {
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
};
const reducer = (previousValue, currentValue) =>
  Number(previousValue) + Number(currentValue);
const Chart = ({ titulo, dataGrafico }) => {
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  function sliceArray(array, index) {
    return array.slice(0, index);
  }
  const backgroundColorData = [
    "rgba(255, 99, 132, 0.2)",
    "rgba(54, 162, 235, 0.2)",
    "rgba(255, 206, 86, 0.2)",
    "rgba(75, 192, 192, 0.2)",
    "rgba(153, 102, 255, 0.2)",
    "rgba(255, 159, 64, 0.2)",
  ];
  const borderColorData = [
    "rgba(255, 99, 132, 1)",
    "rgba(54, 162, 235, 1)",
    "rgba(255, 206, 86, 1)",
    "rgba(75, 192, 192, 1)",
    "rgba(153, 102, 255, 1)",
    "rgba(255, 159, 64, 1)",
  ];
  const [data, setdata] = useState(null);
  const [total] = useState(
    Object.values(dataGrafico.ventas[0]).length === 0
      ? null
      : Object.values(dataGrafico.ventas[0])
          .map((numero) => {
            return Number(numero);
          })
          .reduce(reducer)
          .toFixed(0)
  );
  useEffect(() => {
    const { ventas } = dataGrafico;

    const labels = Object.entries(ventas[0]).map((item) => {
      return `${capitalizeFirstLetter(
        item[0].replace("total_", "")
      )}: ${Math.round((item[1] / total) * 100 * 100) / 100}% - $${item[1]}`;
    });
    const data = Object.values(ventas[0]).map((item) => item);
    const backgroundColor = sliceArray(
      backgroundColorData,
      Object.keys(ventas[0]).length
    );
    const borderColor = sliceArray(
      borderColorData,
      Object.keys(ventas[0]).length
    );

    const datasets = labels.flatMap((label, index) => {
      return [
        {
          label,
          data: [data[index]],
          backgroundColor: [backgroundColor[index]],
          borderColor: [borderColor[index]],
          borderWidth: 1,
        },
      ];
    });
    setdata({
      labels: ["Transacciones"],
      datasets,
    });
    // eslint-disable-next-line
  }, []);
  if (!data) {
    return <Cargando titulo="Cargando Multas" />;
  }
  return (
    <>
      <Typography variant="h5" align="center" color="secondary">
        {titulo}:{" "}
        <Typography variant="h5" color="primary" component={"span"}>
          ${total}
        </Typography>
      </Typography>

      <HorizontalBar data={data} options={options} height={65} />
    </>
  );
};

export default Chart;
